import React, { useState, useCallback, useEffect, useRef } from 'react';
import moment from 'moment';
import GInput from '../common/input/ginput';
import Button from '../pnrEnquiry/common/input/Button';
import Alert from '../common/alert';
import Footer from '../footer/footer';
import AccountLoader from '../manageAccount/accountLoader';
import HeaderNonSrp from '../header/headerNonSrp';
import SubHeader from '../header/subHeader';
import { apiUrl } from '../common/constants';
import { GetRequest, countdown, stopTimer, getparamsString } from '../common/helper';
import { t, PNR_NUMBER, MOBILE_NUMBER, SEARCH, CNTRY_CODE, ENT_CC } from '../../translations/GuestCancel';
import { tPnrCommon, SEND_OTP, RESEND, OTP_RESEND_MSZ, OTP_RESEND_OPT, OTP } from '../../translations/pnrEnquiry/Common';
import { tCommon, LOCKOTP_MSG } from '../../translations/Common';
import { Search } from '../common/icons/svg';
import { renderImg } from '../common/icons/img';


const FeedbackSubmit = () => {
    const params = new URLSearchParams(window.location.search);
    const [pnr, setPnr] = useState(params.get('pnr') || "");
    const [mobile, setMobile] = useState("");
    const [loader, setLoader] = useState(false);
    const [errMsg, setErrorMsg] = useState("");
    const [ccdata, setccData] = useState({ code: '+91', name: 'India' });
    const [showDropFrCountryCode, setShowDropFrCountryCode] = useState(false);
    const [searchCountryCode, setSearchCountryCode] = useState("");
    const [filterCountryData, setFilterCountryData] = useState([]);
    const [countryData, setCountryData] = useState([]);
    const [otpSent, setOtpSent] = useState(false);
    const [resend, setResend] = useState("");
    const [otpNo, setOtpNo] = useState("");
    const [reload, setReload] = useState(false);

    const dropdownRef = useRef();

    useEffect(() => {
        getCountryDetails();
    }, [])

    const getCountryDetails = () => {
        setLoader(true);
        const url = `${apiUrl.getcountryCode}`;
        GetRequest(url)
            .then((response) => {
                setLoader(false);
                let countryData = response.CountriesResult;
                setCountryData(countryData);
                setFilterCountryData(countryData)

            })
            .catch(() => { setLoader(false) });
    };

    const handleccData = (el) => {
        setccData({ code: el.CountryCode, name: el.CountryName })
        setShowDropFrCountryCode(false)
    }

    const handleSearchCountryCode = (searchVal) => {
        setSearchCountryCode(searchVal);
        if (searchVal && searchVal.length > 0) {
            const tempList = countryData.filter((el) => {
                return (el.CountryName.toLowerCase().includes(searchVal.toLowerCase()) || el.CountryCode.toLowerCase().includes(searchVal.toLowerCase()));
            });
            setFilterCountryData(tempList);
        }
    }

    const generateOtp = () => {

        if (ccdata.code == '+91') {
            if (!mobile || String(mobile).length < 10) {
                setErrorMsg("Please Enter Mobile No");
                return false;
            }
        } else {
            if (!mobile || String(mobile).length < 6) {
                setErrorMsg("Please Enter valid International Mobile No");
                return false;
            }
        }

        if (!pnr) {
            setErrorMsg("Please Enter PNR number");
            return false;
        }

        setLoader(true);
        const url = `${apiUrl.generateOTPV2}?mobileNo=${mobile}&type=feedback`;
        GetRequest(url).then(res => {
            //console.log(JSON.parse(res));
            countdown('mobileClock', 3, 0, setResend);
            if (res.Success === true) {
                setOtpSent(true);
                setResend("disable");
            }
            setLoader(false);
        })
    };

    const validateOtp = () => {
        setLoader(true);
        const url = `${apiUrl.validateOTPV2}?OTP=${otpNo}&mobileNo=${mobile}`;
        GetRequest(url).then(result => {
            if (result.Success) {
                stopTimer();
                if (pnr) {
                    getPnrDetail(pnr);
                } else {
                    setLoader(false);
                    setErrorMsg("Please Enter PNR number");
                    return false;
                }
            } else {
                setLoader(false);
                setErrorMsg(result?.IsLocked ? tCommon(LOCKOTP_MSG) : "Please enter valid OTP");
            }
        }).catch((err) => {
            console.log("err", err);
            setLoader(false);
        });
    }

    const getPnrDetail = (pnr) => {
        if (pnr) {
            //setLoader(true);
            const data = {
                PNR: pnr,
                mobile: mobile,
                fb: true,
            };
            const url = `${apiUrl.bookingInfo}` + "?" + getparamsString(data);
            GetRequest(url)
                .then((res) => {
                    setLoader(false);
                    if (res.Status && !res.Error) {
                        let bookingInfo = res.BookingInfo.APIGetBookingDetailsResult[0];
                        if (bookingInfo.PassengerContactNo1 == mobile) {
                            if (bookingInfo.BookingStatus == 'B') {
                                var arrivalTime = moment(bookingInfo.ArrivalTime).add(5, 'hours').format('YYYY-MM-DDTHH:mm:ss');
                                arrivalTime = new Date(arrivalTime).getTime();
                                var currentTime = new Date().getTime();

                                if (arrivalTime <= currentTime) {
                                    window.location.href = `/feedback?pnrNo=${res.pnrToken}`;
                                } else {
                                    setErrorMsg("The PNR entered is currently still in progress. Please try again after the journey is complete to submit your review.");
                                    setReload(true);
                                }
                            } else {
                                setErrorMsg("Please enter valid Details");
                                setReload(true);
                            }
                        } else {
                            setErrorMsg("Please enter valid Details");
                            setReload(true);
                        }
                    } else {
                        setErrorMsg(res.Error);
                        setReload(true);
                    }
                })
                .catch((err) => {
                    setLoader(false);
                    console.log(err);
                });
        } else {
            setErrorMsg("Please Enter PNR number");
        }
    };

    const reloadPage = () => {
        window.location.reload();
    }

    return (
        <div className='guest--cancel--wrapper'>
            {loader && <AccountLoader />}
            <HeaderNonSrp />
            <SubHeader />
            <div className="guest--cancel--inputs">
                <div className="timetable-input-wrap" style={{ position: 'relative' }}>
                    <GInput
                        value={ccdata.code + ' ' + ccdata.name}
                        errMsg={t(ENT_CC)}
                        label={t(CNTRY_CODE)}
                        validation="countrycode"
                        key={"cc"}
                        icon={renderImg("flag-icon")}
                        iconError={renderImg("flag-icon-error")}
                        readonly={true}
                        icon2={renderImg("filter-left-arrow")}
                        onClick={() => setShowDropFrCountryCode(true)}
                        onIconClick={() => setShowDropFrCountryCode(true)}
                    />
                    <div
                        className={showDropFrCountryCode ? "all-data-opt active" : "all-data-opt"}
                    >
                        <div className="sel-input-wrap">
                            <div className="srch-icn">
                                <Search />{" "}
                            </div>
                            <input
                                type="text"
                                placeholder={'Search Country Code'}
                                value={searchCountryCode}
                                onChange={(e) => handleSearchCountryCode(e.target.value)}
                            />
                            <span
                                className="net-drop-up"
                                onClick={() => setShowDropFrCountryCode(false)}
                            ></span>
                        </div>
                        <div></div>
                        <div className="show-all-data scroll" ref={dropdownRef}>
                            {filterCountryData.length > 0 && filterCountryData.map((el, index) => {
                                return (
                                    <div
                                        key={el + "-" + index}
                                        className={
                                            el.CountryCode === ccdata.code
                                                ? " data--list active "
                                                : " data--list "
                                        }
                                        onClick={() => handleccData(el)}
                                    >
                                        {el.CountryCode} {el.CountryName}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
                <GInput
                    type="tel"
                    value={mobile}
                    onChange={(e) => setMobile(e)}
                    validation={ccdata.code == '+91' ? "mobile2" : "imobile"}
                    errMsg="Enter Valid Mobile Number"
                    label={t(MOBILE_NUMBER)}
                    key={"mobileno"}
                    icon={renderImg("phone-icon")}
                    iconError={renderImg("phone-icon-error")}
                />
                <GInput
                    type="text"
                    value={pnr}
                    onChange={(e) => setPnr(e)}
                    errMsg="Enter Pnr Number"
                    label={t(PNR_NUMBER)}
                    key={"pnr"}
                    icon={renderImg('cancel_pnr')}
                    iconError={renderImg("pnr_error")}
                />
                <div style={{ marginTop: '16px' }} className="send-button">
                    {
                        otpSent ?
                            <Button text={tPnrCommon(RESEND)} className={`button ${resend !== "disable" && resend !== "" ? `active` : `disable`}`} extraStyle={{ "height": "48px" }} onClick={() => (resend !== "disable" && resend !== "") && generateOtp()} disabled={resend === "disable" && resend !== "" ? true : false} />
                            :
                            <Button text={tPnrCommon(SEND_OTP)} className={`button ${ccdata.code == '+91' ? `active` : `disable`}`} extraStyle={{ "height": "48px" }} onClick={generateOtp} />
                    }
                </div>
                {otpSent && (
                    <React.Fragment>
                        <div className="feedback-otp-message">
                            <div className="message" style={{ display: 'flex', justifyContent: 'center', marginTop: '6px' }}>
                                {
                                    resend === "" ? "" :
                                        resend === "Resend" ? <span>{tPnrCommon(OTP_RESEND_MSZ)}</span> :
                                            <><span style={{ marginRight: '8px', marginTop: '-2px' }}></span><span>{tPnrCommon(OTP_RESEND_OPT)} </span> <span id="mobileClock" style={{ color: "red", marginLeft: '4px' }}></span></>
                                }
                            </div>
                        </div>
                        <GInput
                            type="text"
                            value={otpNo}
                            onChange={(e) => setOtpNo(e)}
                            errMsg="Enter OTP"
                            label={tPnrCommon(OTP)}
                            key={"otp"}
                            validation={"otp"}
                            icon={renderImg("txn_pwd")}
                            max={6}
                            iconError={renderImg("lock-icon-error")}
                        />
                        <div style={{ marginTop: '16px' }} className="send-button">
                            <Button text={t(SEARCH)} className={`button ${String(otpNo).length === 6 ? `active` : `disable`}`} extraStyle={{ "height": "48px" }} onClick={validateOtp} />
                        </div>
                        <div className="opt--generic--msg">
                            Enter One Time Password OTP sent on to your mobile number
                        </div>
                    </React.Fragment>
                )
                }
            </div>
            {errMsg && (
                <Alert
                    msg={errMsg}
                    error={true}
                    close={() => {
                        setErrorMsg("");
                        if (reload) {
                            reloadPage();
                        }
                    }}
                />
            )}
            <Footer />
        </div>
    )
}
export default FeedbackSubmit;